import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';
import { ThemeSwitch } from 'src/layouts/setting/theme-switch';

const LayoutRoot = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  backgroundImage: `
    radial-gradient(ellipse 90% 60% at 50% -10%, ${theme.palette.primary.main}22, transparent 70%),
    radial-gradient(ellipse 60% 40% at 100% 100%, ${theme.palette.primary.main}12, transparent 60%)
  `,
  display: 'flex',
  flex: '1 1 auto',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: theme.spacing(3, 1.5),
  position: 'relative'
}));

export const Layout = (props) => {
  const { children } = props;
  const { i18n } = useTranslation();
  const t = (en, ar) => (i18n.language === 'ar' ? ar : en);

  return (
    <LayoutRoot>
      <Box
        sx={{
          position: 'absolute',
          right: { xs: 12, sm: 20 },
          top: { xs: 12, sm: 20 },
          zIndex: 1
        }}
      >
        <ThemeSwitch />
      </Box>
      <Box sx={{ maxWidth: 420, width: '100%' }}>
        {children}

        <Box sx={{ mt: 2.5, textAlign: 'center' }}>
          <Link
            component={RouterLink}
            href={paths.dashboard.index}
            sx={{
              color: 'text.secondary',
              fontSize: '0.875rem',
              fontWeight: 500,
              '&:hover': { color: 'primary.main' }
            }}
            underline="hover"
            variant="body2"
          >
            {t('← Continue shopping', '← متابعة التسوق')}
          </Link>
        </Box>
      </Box>
    </LayoutRoot>
  );
};

Layout.propTypes = {
  children: PropTypes.node
};
